<template>
  <el-tabs class="safety" v-model="activeName">
    <el-tab-pane label="安防视频" name="security">
      <security v-if="activeName =='security'" />
    </el-tab-pane>
    <el-tab-pane label="风险指数" name="risk">
      <risk v-if="activeName =='risk'" />
    </el-tab-pane>
    <el-tab-pane label="消防设备" name="firecontrol">
      <firecontrol v-if="activeName =='firecontrol'" />
    </el-tab-pane>
    <el-tab-pane label="实时状态" name="timestatus">
      <timestatus v-if="activeName =='timestatus'" />
    </el-tab-pane>
    <el-tab-pane label="安全区域" name="area">
      <areas v-if="activeName =='area'" />
    </el-tab-pane>
    <el-tab-pane label="风险提示" name="reminder">
      <reminder v-if="activeName =='reminder'" />
    </el-tab-pane>
    <el-tab-pane label="异常预案" name="plan">
      <plan v-if="activeName =='plan'" />
    </el-tab-pane>
    <el-tab-pane label="AI安全" name="ai">
      <ai v-if="activeName =='ai'" />
    </el-tab-pane>
    <el-tab-pane label="行为监控" name="behavior">
      <behavior v-if="activeName =='behavior'" />
    </el-tab-pane>
    <el-tab-pane label="安全运行" name="operation">
      <operation v-if="activeName =='operation'" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import risk from './risk'
import timestatus from './timestatus.vue'
import operation from './operation'
import behavior from './behavior'
import firecontrol from './firecontrol'
import security from './security'
import ai from './ai'
import areas from './area'
import reminder from './reminder'
import plan from './plan'
export default {
  components: {
    risk,
    timestatus,
    operation,
    behavior,
    firecontrol,
    security,
    ai,
    areas,
    reminder,
    plan,
  },
  data() {
    return {
      activeName: 'security',
    }
  },
  mounted() {},
  methods: {
    //进度条
    onPercentChange(per) {
      console.log(per)
    },
  },
}
</script>

<style lang="less">
.safety {
  width: 100%;
  display: flex;
  flex-direction: column; height: 100%; overflow-y: auto;

}
</style>
